/**
 * Created by Andrey Popov on 25.04.22
 */

const ThirdElementPlanner = function () {
    this.thirdElements = [];
};

ThirdElementPlanner.prototype.destructor = function () {
    this.clearTimeout();
};

ThirdElementPlanner.prototype.clearTimeout = function () {
    if (this.timeout !== undefined) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
    }
};

ThirdElementPlanner.prototype.spawnPending = function () {
    if (this.thirdElements.length) {
        this.spawnLastOffer();
    }
};

ThirdElementPlanner.prototype.planNext = function (options) {
    this.thirdElements.push(options);

    this.clearTimeout();
    this.timeout = setTimeout(this.spawnLastOffer.bind(this), options.delay || 0);
};

ThirdElementPlanner.prototype.checkAvailable = function () {
    let count = this.thirdElements.length;

    Merge2.current.field.iterateUnits((x, y, unit) => {
        if (unit.findComponent(ThirdElement)) {
            count++;
        }
    });

    return count < ThirdElement.LIMIT;
};

ThirdElementPlanner.prototype.spawnLastOffer = function () {
    this.clearTimeout();

    if (cleverapps.focusManager.isFocused() || Merge2.current.counter.isActive()) {
        return;
    }

    const options = this.thirdElements.pop();
    if (!options) {
        return;
    }

    const prize = options.target;
    const centerCell = Merge2.current.field.getScreenCenterCell();
    const x = prize.x || centerCell.x;
    const y = prize.y || centerCell.y;

    const slot = Merge2.current.field.findEmptySlot(x, y);
    if (slot) {
        const offer = new Unit({
            code: "thirdelement",
            stage: 0,
            prize: {
                code: prize.code,
                stage: prize.stage
            }
        });
        offer.setPosition(slot.x, slot.y);
        Merge2.current.field.addUnit(slot.x, slot.y, offer);
        Merge2.current.field.onAddUnit(slot.x, slot.y, offer);
        offer.findComponent(ThirdElement).onAppearance();
    }

    if (this.thirdElements.length) {
        this.timeout = setTimeout(this.spawnLastOffer.bind(this), 600);
    }
};
